import { Component, effect, OnDestroy, OnInit, signal, Signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NgbAlertModule } from '@ng-bootstrap/ng-bootstrap';
import { HeaderComponent } from './header/header.component';
import { LoadingIndicatorComponent } from './shared/components/loading-indicator/loading-indicator.component';
import { BehaviorSubject, Subscription } from 'rxjs';
import { LoggerService } from './shared/logger.service';
import { SettingsService } from './settings/settings.service';
import { AuthTokenService } from './auth/auth-token.service';
import { AppStateService } from './shared/app-state.service';
import { debounceSignal } from './common/utils.lib';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FooterComponent } from './footer/footer.component.js';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    NgbAlertModule,
    HeaderComponent,
    LoadingIndicatorComponent,
    MatSlideToggleModule,
    FooterComponent
  ],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit, OnDestroy {
  protected readonly title = signal('COPPR');

  private _isLoggedIn = new BehaviorSubject<boolean>(this.authTokenService.loggedInComputed());
  get isLoggedIn() {
    return this._isLoggedIn.getValue();
  }
  set isLoggedIn(val: boolean) {
    this._isLoggedIn.next(val);
  }
  private _subs: Subscription[] = [];

  $query = signal<any>('');
  debounceQuery!: Signal<string>;
  querySignal = signal(this.$query());

  constructor(
    private logger: LoggerService,
    private settingsService: SettingsService,
    private authTokenService: AuthTokenService,
    private appStateService: AppStateService
  ) {
    this.debounceQuery = debounceSignal(this.$query, 1000);
    effect(() => {
      let temp = this.debounceQuery();
      this.isLoggedIn = this.authTokenService.loggedInComputed();
      this.querySignal.set(temp);
    })
  }

  ngOnInit(): void {
    // this.logger.debug('app component: ngOnInit...');
    // console.log(`Wally Rules`);
    // this.trackerService
    // window.electronAPI.onSendDefaultSettings((event: any, defaults: IEnvVars) => {
    //   this.logger.log(`${event}: `, JSON.stringify(defaults));
    this.settingsService.initialize();
    this.appStateService.initialize();
    //   this.apiService.setApiUrl(this.settingsService.settings?.apiUrl)
    // });
    // window.electronAPI.onKillTheApp((event: any, args: any) => {
    //   this.logger.log(`kill-the-app`, args);
    //   this.authTokenService.removeToken();
    //   window.electronAPI.quitTheApp(`tokens removed...`);
    // });
    // this.logger.log(window.electronAPI.sendSettings(args))
    // this._subs.push(this.authTokenService.isLoggedIn$.subscribe(status => {
    //   this.logger.debug('status changed: **>> ', status);
    //   this.isLoggedIn = status;
    // }));

  }

  ngOnDestroy(): void {
    // this.logger.debug('ngOnDestroy...');
    this._subs.forEach(s => s.unsubscribe());
  }

  onSearchInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.$query.set(input.value);
  }

}
